var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitening({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1501,
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M659.32 534.092c70.548-40.828 118.048-117.06 118.048-204.432H659.32v204.432z",
    fill: "#FFFFFF",
    "p-id": 1503
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M718.344 485.74c36.724-41.596 59.024-96.22 59.024-156.076h-59.024v156.076z",
    fill: "#D4E7F8",
    "p-id": 1504
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.228 534.092V329.664H305.18c0 87.372 47.5 163.6 118.048 204.428zM423.228 329.664v204.432a234.928 234.928 0 0 0 118.048 31.664V329.664h-118.048z",
    fill: "#FFFFFF",
    "p-id": 1505
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M659.32 329.664h-118.048v236.096a234.928 234.928 0 0 0 118.048-31.664V329.664z",
    fill: "#FFFFFF",
    "p-id": 1506
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M541.276 472.576c-73.528 0-147.052-11.22-218.532-33.652a12 12 0 1 1 7.188-22.9c138.252 43.388 284.42 43.396 422.684 0a12 12 0 1 1 7.188 22.9c-71.48 22.432-145.004 33.652-218.528 33.652z",
    fill: "#504774",
    "p-id": 1507
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M423.228 546.092a12.04 12.04 0 0 1-6.012-1.612c-76.508-44.276-124.036-126.588-124.036-214.816a12 12 0 0 1 12-12h118.048a12 12 0 0 1 12 12v204.428a12 12 0 0 1-12 12zM317.504 341.664c3.68 67.98 38.468 130.928 93.724 170.432V341.664H317.504z",
    fill: "#504774",
    "p-id": 1508
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M541.272 577.756a248.024 248.024 0 0 1-124.06-33.276 12 12 0 0 1-5.988-10.388V329.664a12 12 0 0 1 12-12h118.048a12 12 0 0 1 12 12v236.092c0 6.632-5.368 12-12 12z m-106.044-50.704a224.04 224.04 0 0 0 94.048 26.384V341.664h-94.048v185.388z",
    fill: "#504774",
    "p-id": 1509
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M541.272 577.756a12 12 0 0 1-12-12V329.664a12 12 0 0 1 12-12h118.048a12 12 0 0 1 12 12v204.428a12 12 0 0 1-5.988 10.388 247.972 247.972 0 0 1-124.06 33.276z m12-236.092v211.768a223.92 223.92 0 0 0 94.048-26.384V341.664h-94.048z",
    fill: "#504774",
    "p-id": 1510
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M659.32 546.092a11.992 11.992 0 0 1-12-12V329.664a12 12 0 0 1 12-12h118.048a12 12 0 0 1 12 12c0 88.228-47.528 170.54-124.036 214.816a11.996 11.996 0 0 1-6.012 1.612z m12-204.428v170.432c55.252-39.5 90.044-102.448 93.724-170.432H671.32zM252.084 377.08a12 12 0 0 1-11.868-10.332l-0.068-0.472c-5.46-40.04 9.888-79.236 41.044-104.896a12.004 12.004 0 0 1 15.26 18.524c-24.688 20.332-36.848 51.392-32.528 83.084l0.06 0.424a12 12 0 0 1-11.9 13.668zM830.464 377.08a11.992 11.992 0 0 1-11.908-13.572l0.064-0.472c4.324-31.74-7.832-62.796-32.524-83.128a12 12 0 0 1 15.26-18.524c31.156 25.656 46.504 64.852 41.052 104.848l-0.06 0.424a12.008 12.008 0 0 1-11.884 10.424z",
    fill: "#504774",
    "p-id": 1511
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M263.624 753.36l-71.088-54.088 205.668-259.1 60.292 45.876z",
    fill: "#A0D1F2",
    "p-id": 1512
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M428.348 463.104l-22.776-17.332 44.94-35.424 44.936-35.428-22.16 52.756-22.164 52.756z",
    fill: "#FFFFFF",
    "p-id": 1513
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M458.496 486.048l-22.78-17.336-194.872 267.316 22.78 17.332z",
    fill: "#7BABF3",
    "p-id": 1514
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.624 765.36a12.008 12.008 0 0 1-7.264-2.448l-71.088-54.088a11.996 11.996 0 0 1-2.132-17.012l205.672-259.096a12.004 12.004 0 0 1 16.664-2.088l60.288 45.876a12 12 0 0 1 2.428 16.62L273.32 760.428a12 12 0 0 1-9.696 4.932z m-54.072-68.224l51.592 39.256 180.732-247.916-41.58-31.636-190.744 240.296z",
    fill: "#504774",
    "p-id": 1515
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M451.124 492.432a12.008 12.008 0 0 1-7.264-2.448l-45.552-34.66a12.012 12.012 0 0 1-0.164-18.976l89.876-70.852a11.996 11.996 0 0 1 18.492 14.072l-44.324 105.516a12 12 0 0 1-11.064 7.348z m-25.956-46.828l20.896 15.9 20.324-48.392-41.22 32.492zM429.732 535.84a11.936 11.936 0 0 1-7.256-2.448l-60.288-45.876a12 12 0 0 1 14.532-19.1l60.288 45.876a12 12 0 0 1-7.276 21.548z",
    fill: "#504774",
    "p-id": 1516
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitening);
export default __webpack_public_path__ + "static/media/whitening.674b07f669d1ea9cdc8b24b85bb5a02f.svg";
export { ForwardRef as ReactComponent };